export default "__VITE_ASSET__CSjHT09W__"